import { useOrgSettings } from "@/hooks/useOrgSettings";

type LeadDeviceDevToolsProps = {
  resetSetupOnly: () => void;
  resetAllData: () => void;
  copyLeadsJson: () => void;
};

export function LeadDeviceDevTools({ resetSetupOnly, resetAllData, copyLeadsJson }: LeadDeviceDevToolsProps) {
  const { appDisplayName } = useOrgSettings();
  return (
    <details className="mt-10 text-left text-sm text-gray-600">
      <summary className="cursor-pointer text-blue-600 text-base">Developer: Device tools</summary>

      <div className="mt-4 border border-gray-300 rounded-xl p-4 bg-gray-50 space-y-4">
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={resetSetupOnly}
            className="px-3 py-2 rounded-xl border border-amber-300 text-xs text-amber-700 bg-white hover:bg-amber-50"
          >
            Clear saved profile and lot (keep leads)
          </button>

          <button
            type="button"
            onClick={resetAllData}
            className="px-3 py-2 rounded-xl border border-red-300 text-xs text-red-600 bg-white hover:bg-red-50"
          >
            Reset {appDisplayName} on this device
          </button>

          <button
            type="button"
            onClick={copyLeadsJson}
            className="px-3 py-2 rounded-xl border border-gray-300 text-xs text-gray-700 bg-white hover:bg-gray-50"
          >
            Copy all leads JSON
          </button>
        </div>
      </div>
    </details>
  );
}
